import { render, staticRenderFns } from "./StageItem.vue?vue&type=template&id=7a9829cf&"
import script from "./StageItem.vue?vue&type=script&lang=js&"
export * from "./StageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports